module.exports = __webpack_public_path__ + "img/dish-placeholder.d6514d3d.svg";